// 타임라인이 있을 경우
if ( NP.timeline.length ) {

NP.isEnded = false;
NP.contentCount = 0;

// Get Time
NP.Time = function( time ) {
	/*
		- 0~60초		: 예) 지금 막
		- 1~60분		: 각 분단위로 표시 예) 1분 전
		- 1시간~24시간	: 시간단위로 표시 예) 약 1시간 전
		- 1일이상		: 날짜 및 시간으로 표시 예) 2011.05.23 11:10:10

		- 60000 = 60초
		- 3600000 = 60분
		- 86400000 = 24시간
	*/

	var diff = ( NP.now - time ) / 1000,
		past = new Date( time ),
		leadingZeros = function( n, digits ) {
			var zero = '',
				len = n.toString().length,
				i = 0;

			if ( len < digits ) {
				for ( ; i < digits - len; i += 1 ) {
					zero += '0';
				}
			}

			return zero + n;
		};

	if ( diff < 60 ) {
		time = '지금 막';
	} else if ( diff >= 60 && diff < 3600 ) {
		time = parseInt( diff / 60 ) + '분 전';
	} else if ( diff >= 3600 && diff < 86400 ) {
		time = '약 ' + parseInt( diff / ( 60 * 60 ) ) + '시간 전';
	} else if ( diff >= 86400 ) {
		time = leadingZeros( past.getFullYear(), 4 ) + '.' + leadingZeros( past.getMonth() + 1, 2 ) + '.' + leadingZeros( past.getDate(), 2 ) + ' ' + leadingZeros( past.getHours(), 2 ) + ':' + leadingZeros( past.getMinutes(), 2 ) + ':' + leadingZeros( past.getSeconds(), 2 );
	}

	return time;
};
NP.Time.term = 60000; // 1분
NP.Time.set = function() {
	var timeEl = NP.body.find( 'time' ),
		time,
		save,
		el;

	NP.now = NP.now + NP.Time.term;

	jQuery.each( timeEl, function( index ) {
		el = jQuery( this );
		time = jQuery.data( el[ 0 ] ).time;
		save = NP.Time( time );

		if ( time && el.text() !== save ) {
			NP.fadeIn( el.text( save ).css( 'opacity', 0.2 ) );
		}
	});

	setTimeout( NP.Time.set, NP.Time.term );
};

NP.charInfo = {};
// Timeline
NP.Timeline = (function( $ ) {
	var tplParser = NP.ns( 'Util.tplParser' ),
		ellipsis = NP.ns( 'Util.ellipsis' ),
		getParam = NP.ns( 'Util.getParam' ),
		validate = NP.ns( 'Util.validate' ),
		saveLastNum,
		limitLength = 500,
		writable = 0, // 0 : 글쓰기 권한 없음, 1 : 글쓰기 권한 있음, 2 : 제재된 계정(권한없음)
		loading = $( '<p class="loading_timeline"></p>' ),
		isLoaded = false;

	var feedReplace = function( data, postData ){
		var limitLength = 500;
		var contents = data;
		var feedContents = '';
		var _prefix = '';
		
		//공방 제작 추가
		_prefix = data.match( /^<em class="em_gf">\[.+\]<\/em>|<em class="em_gf_groupWorkshop">\[.+\]<\/em>/ );

		if ( _prefix && _prefix[ 0 ] ) {
			data = data.substr( _prefix[ 0 ].length );
		}else{
			_prefix = '';
		}
		
		if( /isGameFeed|<section class/i.test(data) ){
			var idx = data.indexOf( '<section' );
			contents = data.substr( 0, idx );
			feedContents = data.substr( idx );
			feedContents = feedContents
				.replace('http://static.plaync.co.kr','https://wstatic-cdn.plaync.com')
				.replace('http://imgfiles.plaync.com','https://imgfiles-cdn.plaync.com')
				.replace('http://upload.plaync.co.kr','https://imgfiles-cdn.plaync.com')
				.replace('http://profileimg.plaync.com','https://profileimg.plaync.com');
		}

		if ( contents.length > limitLength ) {
			postData.siempre = contents;
			contents = ellipsis( contents, limitLength );
		}

		contents = NP.AutoLink( validate( contents.replace( /\n/g, '<br />' ) ) );

		return _prefix + contents + feedContents;
	}

	// Set Data
	NP.onProcessing.add(function( article, datum ) {
		
		try {
			$.each( article, function( index ) {

				var item = $( this ),
					reply,
					aData = datum[ index ] || datum;

				item.attr( 'id', 'article_' + ( aData.postTxtSeq || aData.post.postTxtSeq) );
				
				if ( aData.actType === "LIKE_POST" ) {
					$.data( item[ 0 ], {
						orgPostTxtSeq : aData.refTimeline && aData.refTimeline.post.postTxtSeq,
						orgActType : aData.refTimeline && aData.refTimeline.actType,
						orgWrtPlayncAcctId : aData.refTimeline && aData.refTimeline.post.wrtPlayncAcctId,
						orgWrtPlayncAcctNm : aData.refTimeline && aData.refTimeline.post.wrtPlayncAcctNm
					});
				}
				
				// 글
				$.data( item[ 0 ], {
					postTxtSeq : aData.postTxtSeq || aData.post.postTxtSeq, // 글 번호
					postTorg: aData.postTorg,
					actType : aData.actType, // Activity 종류
					wrtPlayncAcctId : aData.post.wrtPlayncAcctId, // 작성자 GUID
					wrtPlayncAcctNm : aData.post.wrtPlayncAcctNm, // 작성자 닉네임
					postTxtTorgId : aData.post.postTxtTorgId, // 글주인 GUID
					postTxtOpenClfSeq : aData.post.postTxtOpenClfSeq // 글 공개 구분
				});

				// 댓글
				if ( aData.refTimeline && aData.refTimeline.replyList && aData.refTimeline.replyList.length ) { // 좋아요 한 글일 경우
					reply = item.find( '.list_comment li' );
					NP.onProcessingReply.fire( reply, aData.refTimeline.replyList );
				} else {
					reply = item.find( '.list_comment li' );
					NP.onProcessingReply.fire( reply, ( aData.replyList ) );
				}
				/*if ( ( aData.refTimeline && aData.refTimeline.replyList.length ) || ( aData.replyList && aData.replyList.length ) ) {
					reply = item.find( '.list_comment li' );
					NP.onProcessingReply.fire( reply, ( aData.refTimeline.replyList || aData.replyList ) );
				}*/

				// 글 시간
				if ( item = item.find( 'time' )[ 0 ] ) {
					$.data( item, {
						time : aData.post.creDttm
					});
				}
			});
		} catch( e ) {}
	});

	// 글 조회
	NP.timeline.length && NP.onDomLoad.add(function() {
		var postTxtSeq = getParam( 'postTxtSeq' );

		NP.onBeforeGetTimeline.fire(function() {
			if ( !parseInt( postTxtSeq ) ) { // 타임라인 글 조회
				NP.Timeline.get();
			} else { // 글 하나 조회
				NP.Timeline.getOne( postTxtSeq );
			}
		});

		/* if ( !parseInt( postTxtSeq ) ) { // 타임라인 글 조회
			NP.Timeline.get();
		} else { // 글 하나 조회
			NP.Timeline.getOne( postTxtSeq );
		} */
	});

	// 더보기
	NP.timeline.on( 'click', 'article .viewOrigin a', function() {
		var button = $( this ),
			wrap = button.parent(),
			origin = button.next().eq( 0 ),
			content = wrap.prev( '.content' ),
			//infoTxt = content.find( '.info' ).clone().wrapAll( '<div/>').parent().html();
			infoTxt = content.find( '.info' ).html();
		
		infoTxt = '<div class="info">' + infoTxt + '</div>';

		content.replaceWith( origin.html().replace(/\n/gi, '<br>') + infoTxt );
		origin.remove();
		wrap.remove();
	});

	// 시간 갱신
	function timeRefresh() {
		setTimeout( NP.Time.set, NP.Time.term );
		NP.onAfterTimelineLoad.remove( timeRefresh );
	}
	NP.onAfterTimelineLoad.add( timeRefresh );

	/* 디버깅용 코드 */
	/* NP.Debug && NP.timeline.on( 'click', 'article, article .list_comment li, article time', function() {
		console.log( $.data( $( this )[ 0 ] ) );
	}); */

	return {
		// 글 목록 조회
		get : function( lastNum ) {
			if( NP.isLoading ) return;
			
			if( !NP.dt ) return;

			var ownerGuid = ( !NP.dt.o && NP.dt.st == 'aion' && ( NP.dt.loc ==  'characterguestbook' || NP.dt.loc ==  'groupguestbook' ) )? 
					'!!': NP.dt.o; 
			$.ajax({
				type : 'get',
				dataType : 'jsonp',
				url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + ownerGuid + '/' + NP.dt.st + '/timeline/more.jsonp?' + $.param({
					lastNum : lastNum || 0, // 글 목록 호출 시에는 0, 더보기 시에는 X번째
					page : NP.dt.page, // timeline | wall
					trgtId : getParam( 'trgtId' ),
					postTxtSeq : 0,
					guildId: NP.dt.guildId || '',
					characterId: NP.dt.characterId || '',
					serverId: NP.dt.serverId || ''
				}),
				beforeSend : function() {
					NP.isLoading = !0;
					NP.timeline.prepend( loading );
				},
				complete : function() {
					NP.isLoading = !1;
					NP.fadeOut( loading );
				},
				success : function( data ) {
					NP.Timeline.set( data, false, lastNum );
				},
				error: function( data ){
					var html = tplParser( NP.tmpl.systemErr )({}),
						writeWrap = $( '#writeShort' );
					
					NP.timeline.append( html );
					writeWrap.hide();
					NP.ScrollToLoad.clear();
					return;
				}
			});
		},
		getOne : function( postTxtSeq ) {
			var ownerGuid = ( !NP.dt.o && NP.dt.st == 'aion' && ( NP.dt.loc ==  'characterguestbook' || NP.dt.loc ==  'groupguestbook' ) )? 
					'!!': NP.dt.o; 
			$.ajax({
				type : 'get',
				dataType : 'jsonp',
				url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + ownerGuid + '/' + NP.dt.st + '/timeline/more.jsonp?' + $.param({
					lastNum : 0, // 글 목록 호출 시에는 0, 더보기 시에는 X번째
					page :NP.dt.page,
					trgtId : getParam( 'trgtId' ),
					postTxtSeq : postTxtSeq,
					guildId: NP.dt.guildId || '',
					characterId: NP.dt.characterId || '',
					serverId: NP.dt.serverId || ''
				}),
				success : function( data ) {
					if ( !data.timeline ) { // TODO 없는 글을 조회했을 때 처리는?
						NP.timeline.append( '존재하지 않는 게시글입니다.' );

						return;
					}

					//NP.Timeline.setOne( data );
					NP.Timeline.set( data, true );
				}
			});
		},
		set : function( data, one, callLastNum ) { // one이 true 면 글 하나 조회
			var tplParser = NP.ns( 'Util.tplParser' ),
				html = '',
				template,
				article,
				count = 0,
				i = 0;

			var writeWrap = $( '#writeShort' );
			
			if ( data.systemException ) {

				html = tplParser( NP.tmpl.systemErr )({});
				NP.timeline.append( html );
				writeWrap.hide();
				NP.ScrollToLoad.clear();
				return;
			};
			
			// 글쓰기 권한 저장
			writable = data.writable;
			// 타임라인 마지막 flag
			NP.isLast = data.isLast;
			
			openClfSeq = 118;
			guestbookOpenClfSeq = 118;
			isMyCharacter = data.isMyCharacter;
			
			if( data.guestbook ) guestbookOpenClfSeq = data.guestbook.openClfSeq;
			
			
			// 타임라인 갱신 시 글쓰기 권한이 사라지면 글쓰기 form 초기화
			if ( writable === 0 || writable === 2 ) {
				NP.WriteForm.reset();
			}
			
			if( data.isMyCharacter || data.isFriend || data.isFrind ){
				openClfSeq = 118;
			}
			
			if( data.guestbook ){
				//비공개
				if( data.guestbook.openClfSeq == 121 ){
					openClfSeq = 121;
					NP.ScrollToLoad.clear();
					html = tplParser( ( NP.dt.page == 'groupguestbook' )? NP.tmpl.closedGroup: NP.tmpl.closedCharacter )( NP.dt );
					NP.timeline.append( html );
					writeWrap.hide();
					
					//방명록 공개설정
					NP.Timeline.setOpen();
					return;
				}
				
				//친구공개
				if( data.guestbook.openClfSeq == 119 ){
					if( data.isMyCharacter || data.isFriend || data.isFrind ){
						openClfSeq = 118;
					}else{
						openClfSeq = 119;
						NP.ScrollToLoad.clear();
						html = tplParser( NP.tmpl.closedFrdCharacter )( NP.dt );
						NP.timeline.append( html );
						writeWrap.hide();
						
						//방명록 공개설정
						NP.Timeline.setOpen();
						return;			
					}
				}
				
				if( data.guestbook.openClfSeq == 118 ){
					//전체공개
					openClfSeq = 118;
				}
			}

			//제작공방, 기부/승인 모아보기 시 글쓰기 hide
			if( NP.dt.st == 'bns' && ( NP.dt.loc == 'groupdonate' || NP.dt.loc == 'groupsign' || NP.dt.loc == 'groupreceive' ) ){
				writeWrap.hide();
				if(  !isLoaded &&  data.timeline.length < 5 ){
					jQuery( '.moreArticle' ).hide();NP.onAfterTimelineLoad.fire();
				}
			};
			
			if ( data.selector && !data.selector.totalCnt && !data.timeline.length ) { // 글이 없는 경우 = NP 서비스가 열림 | 문파 시작
				//if ( !data.timeline.length ) {
					
				if ( NP.dt.loc !== 'group' && NP.dt.loc !== 'characterguestbook' && NP.dt.loc !== 'groupguestbook' 
					&& NP.dt.loc !== 'groupdonate' && NP.dt.loc !== 'groupsign' && NP.dt.loc !== 'groupreceive' ) {
						if( !callLastNum ) NP.timeline.find( '.wrap_recommendBns' ).show();

					NP.onAfterTimelineLoad.fire();
				}

				if( !isLoaded && NP.dt.st == 'bns' && ( NP.dt.loc == 'groupdonate' || NP.dt.loc == 'groupsign' || NP.dt.loc == 'groupreceive' ) ){
					NP.timeline.append( tplParser( NP.tmpl.noneData )( NP.dt ) );
					NP.onAfterTimelineLoad.fire();
				}

				if( !isLoaded && data.timeline.length < 5 ){
					if ( !NP.Util.getParam( 'postTxtSeq' ) ) {
						if ( NP.dt.loc === 'group' ) {
							if( !jQuery( '.openServiceGroupInfo' ).length ) 
								NP.timeline.append( tplParser( NP.tmpl.openGroup )( NP.dt ) );
						} else if( NP.dt.loc === 'characterguestbook' ){
							if( !jQuery( '.openServiceInfo' ).length ) 
								NP.timeline.append( tplParser( NP.tmpl.openGuestbook )( NP.dt ) );
						}else if( NP.dt.loc === 'groupguestbook' ){
							if( !jQuery( '.openServiceGroupInfo' ).length ) 
								NP.timeline.append( tplParser( NP.tmpl.openGroupGuestbook )( NP.dt ) );
						}else if( NP.dt.loc === 'groupdonate' || NP.dt.loc === 'groupsign' || NP.dt.loc == 'groupreceive' ){
						
						}else{
							if( !jQuery( '.openServiceInfo' ).length ) 
								NP.timeline.append( tplParser( NP.tmpl.open )( NP.dt ) );
						}
					}
					NP.onAfterTimelineLoad.fire();

					return;
				}				

				return;
			}




			NP.now = data.now || +new Date(); // 서버로부터 받은 현재 시간
			saveLastNum = data.selector && data.selector.lastNum; // 로드된 마지막 글 번호

			for ( ; article = data.timeline[ i ]; i += 1 ) {
				if ( ( article.refTimeline && article.refTimeline.post.delYn === 'Y' ) || article.post.delYn === 'Y' ) {
					count++;
					html += '<article class="resultAction" style="display:none" data-count="'+count+'">삭제된 글입니다.</article>';

					if ( count == 15 ) {
						NP.Timeline.get( saveLastNum );
					}
				} else if ( ( article.refTimeline && article.refTimeline.post.virtTxtYn === 'Y' ) ||  article.post.virtTxtYn === 'Y' ) { // 가상글일 경우( 외부글로 인해 발생한 )
					count++;
					html += '<article class="resultAction" style="display:none" data-count="'+count+'">존재하지 않는 글입니다.</article>';
					
					if ( count == 15 ) {
						NP.Timeline.get( saveLastNum );
					}
				} else {

					/*
					 *article.post.postTxtTorgClfSeq
					 *114 그룹 일반
					 *155 그룹 기능
					 *156 그룹 승인
					 */

					if ( article.actType === 'POST' ) { // 글
						template = NP.tmpl.article; // 내 공간에 쓴 글
						
						//TODO
						if( article.post && article.post.wrtChrtNm ){
							article.post.wrtChrtNm = article.post.wrtChrtNm.replace( /</g, '&lt;' ).replace( />/g, '&gt;' );
						}

						//article.postTorg !== "GROUP" && article.postTorg !== "GROUP_DONATE"
						if ( NP.dt.loc === 'wall' && 
							article.post.postTxtTorgClfSeq !== 114 && article.post.postTxtTorgClfSeq !== 155 && article.post.postTxtTorgClfSeq !== 156 && 
							article.post.postTxtTorgId !== article.post.wrtPlayncAcctId ) { // 다른 공간에 쓴 글, 그룹글은 제외
								template = NP.tmpl.articleTo;
						}
						
						if ( article.post.extPostTxtId ) { // 외부글
							template = NP.tmpl.articleExt;
							article.post.postTxtLongCont = $.trim( article.post.postTxtLongCont );
						}

						article.post.postTxtLongCont = feedReplace( article.post.postTxtLongCont, article.post );
					} else if ( article.actType === 'LIKE_POST' ) {
						//template = NP.tmpl.actType[ article.actType ];
						template = NP.tmpl.article; // 내 공간에 쓴 글

						// Data Manipulation
						article.refTimeline.orgActType = article.actType;
						article.refTimeline.orgPostTxtServClfSeq = article.post.postTxtServClfSeq;
						article.refTimeline.orgPostTxtTorgGameId = article.post.postTxtTorgGameId;
						article.refTimeline.postTxtTorgGameId = article.post.postTxtTorgGameId;
						article.refTimeline.orgWrtPlayncAccId = article.post.wrtPlayncAcctId;
						article.refTimeline.orgWrtPlayncAccNm = article.post.wrtPlayncAcctNm;
						article.refTimeline.orgWrtChrtNm = article.post.wrtChrtNm;
						article.refTimeline.orgWrtSvrId = article.post.wrtSvrId;
						article.refTimeline.orgWrtChrtId = article.post.wrtChrtId;
						article.refTimeline.orgWrtGameId = article.post.wrtGameId;
						article.refTimeline.orgCreDttm = article.post.creDttm;
						article = article.refTimeline;

						if ( article.post.postTxtTorgId !== article.post.wrtPlayncAcctId ) { // 다른 공간에 쓴 글
							template = NP.tmpl.articleTo;
						}
						
						if ( article.post.extPostTxtId ) { // 외부글
							template = NP.tmpl.articleExt;
						}

						article.post.postTxtLongCont = feedReplace( article.post.postTxtLongCont, article.post );
					} else if ( NP.tmpl.actType[ article.actType ] ) { // Activity 글
						//<a href="/00B8C304-F370-4D82-91B7-A006B7A5C7FF?postTxtSeq=84750881"><input type="text" value="bbb" onMouseOver="prompt(4455)"></a>
						template = NP.tmpl.activity;

						if ( article.data ) { // 닉네임 변경, 프로필 정보 변경, 프로필 사진 변경
							article.data = article.data.split( '$!' ); // 개발팀에서 분기를 위해 찍어주는 특수문자
						}
						
						article.post.postTxtLongCont = ( tplParser( NP.tmpl.actType[ article.actType ] )( article ) );
					};
					
					html += NP.likeByArticle( tplParser( template )( article ), article );
					
				}

				
				NP.charInfo.wrtChrtNm = article.post.postTxtTorgNm;
				NP.charInfo.wrtSvrId = article.post.postTxtTorgSvrId;
				NP.charInfo.wrtChrtId = article.post.postTxtTorgChrtId;
				NP.charInfo.wrtGameId = article.post.postTxtTorgGameId;
				
			}

			count = 0;

			html = $( html );

			NP.onProcessing.fire( html, data.timeline );
			NP.timeline.append( html );
			NP.onAfterTimelineLoad.fire();

			isLoaded = true;

		},
		getLastNum : function() {
			return saveLastNum;
		},
		writable : function() {
			return writable;
		},
		openClfSeq : function(){
			return openClfSeq;
		},
		guestbookOpenClfSeq: function(){
			return guestbookOpenClfSeq;
		},
		isMyCharacter: function(){
			return !!isMyCharacter;
		},
		setOpen: function(){
			if( ( NP.dt.page == 'characterguestbook' && isMyCharacter ) || ( NP.dt.page == 'groupguestbook' && NP.dt.isGuildMaster == 'true' ) ){
				
				var guestbookBtn = $( '#guestbookOpenSetting' ),
					modalCharSetting = $( '#modalCharSetting' ),
					modalGroupSetting = $( '#modalGroupSetting'),
					layer = '',
					openValue = function( seq ){
						var txt = 'all';
						switch( seq ){
						case 118:
							txt = 'all';
							break;
						case 119:
							txt = 'npfriend';
							break;
						case 121:
							txt = 'private';
							break;
						}
						
						return txt;
					
					},
					btnTxt = function( seq ){
						var txt = '전체공개';
						switch( seq ){
						case 118:
							txt = '전체공개';
							break;
						case 119:
							txt = 'NC친구공개';
							break;
						case 121:
							txt = '비공개';
							break;
						}
						
						return txt;						
					};
					
				guestbookBtn.show();

				if( guestbookBtn.length ){
					if( NP.dt.page === 'characterguestbook'){
						if( !modalCharSetting.length ){
							guestbookBtn.parent().append( tplParser( NP.tmpl.modalCharSetting )() );
						}		
						
						layer = $( '#modalCharSetting' );

					}else{
						if( !modalGroupSetting.length )
							guestbookBtn.parent().append( tplParser( NP.tmpl.modalGroupSetting )() );
						
						layer = $( '#modalGroupSetting' );
					}
					
					$( '#guestbookOpenBtn' ).show();
					
					$( '#guestbookOpenBtn' ).on( 'click', function( e ){
						e.preventDefault();
						layer.find( 'input:radio[value="'+ openValue( NP.Timeline.guestbookOpenClfSeq() ) +'"]').prop( 'checked', true );
						layer.show();						
					});
					
					guestbookBtn.off().on( 'click', function( e ){
						e.preventDefault();
						layer.find( 'input:radio[value="'+ openValue( NP.Timeline.guestbookOpenClfSeq() ) +'"]').prop( 'checked', true );
						layer.show();
					});

					guestbookBtn.attr( 'class', 'btn_option js_tooltip' );
					guestbookBtn.attr( 'data-tooltip', '캐릭터방명록 공개설정' );
					guestbookBtn.text( btnTxt( NP.Timeline.guestbookOpenClfSeq() ) );	
				};
				
				if( layer ){
					
					layer.find( '.apply' ).on( 'click', function(){
						
						if( !NP.dt.o ){
							modal.show({
								txt : '로그인이 필요합니다.'
							});
							return;	
						}

						var type = 'character',
							data = {
								c: NP.dt.characterId || NP.dt.vCharId,
								s: NP.dt.serverId || NP.dt.vServerId,
								p: layer.find( 'input:radio[checked]' ).val() || 'all'
							};
						
						if( NP.dt.page === 'groupguestbook' ){
							type = 'group';
							data = {
								g: NP.dt.guildId,
								s: NP.dt.serverId || NP.dt.vServerId,
								p: layer.find( 'input:radio[checked]' ).val() || 'all'
							}
						};
						
						$.ajax({
							type : 'get',
							dataType : 'jsonp',
							url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/'+ NP.dt.o +'/'+ NP.dt.st +'/guestbook/'+ type +'/permission.jsonp',
							data : data,
							success : function( data ) {
								if( data.result == 'SUCCESS'){
									location.reload();
									//layer.hide();
								}else if( data.result == 'NOT_HOST_MINE'){
									modal.show({
										txt : '권한이 없습니다.'
									});
								}else{
									
								}
								
							},
							error : function() {
//								modal.show({
//									txt : '작업이 지연되고 있습니다. 잠시 후 이용 해 주세요.'
//								});
							}
						});

					});
					
					layer.find( '.cancel' ).on( 'click', function(){
						layer.hide();
					});
					
					layer.find( '.btnCloseLayer' ).on( 'click', function(){
						layer.hide();
					});
				}
			}			
		}
	};
}( jQuery ));


// Write Form
NP.WriteForm = (function( $ ) {
	var timer, fake = $( '<div style="display:none;line-height:1.5;" />' ),
		writeShort = $( '#writeShort' ),
		buttonWrite = writeShort.find( '.btn_write' ),
		buttonWriteCancel = writeShort.find( '.btn_cancel' ),
		textarea = writeShort.find( '.textarea textarea' ).val( '' ),
		validate = NP.ns( 'Util.validate' ),
		getParam = NP.ns( 'Util.getParam' ),
		tplParser = NP.ns( 'Util.tplParser' ),
		isIE = !!navigator.userAgent.toLowerCase().match( /msie|trident/ ),
		fakeHtml = '',
		defHeight = 54;

	function check() {
		clearTimeout( timer );

		var height;

		if ( !textarea.val().replace( /\s/g, '' ).length ) {
			height = defHeight;
		} else {
			fake.html( validate( textarea.val() ).replace( /\n/g, '<br />' ) );
			//fake.html( textarea.val() );

			var fakeHeight = fake.height();

			if( fake.html() == fakeHtml ) return;
			
			if ( !( /\<br\>$/.test( fake.html() ) ) ) {
				height = fakeHeight <= defHeight ? defHeight : fakeHeight;
				textarea.height( height );
			} else {
				height = textarea[ 0 ].scrollHeight;
				//textarea.height( height );
			}
			
			fakeHtml = fake.html();
		}

		if ( !isIE ) {
			timer = setTimeout( check, 100 );
		}
	}

	writeShort.find( '.welcome' ).click(function() {
		mustLoginIfHasNoSession() && NP.WriteForm.check(function() {
			textarea.focus();
		});		
		
		/*var writable = writable();

		if ( writable === 1 ) {
			//textarea.focusin().focus();
			textarea.focus();
		} else if ( writable === 0 ) {
			modal.show({
				txt : '<strong>' + NP.dt.oNm + '</strong><b>님은 친구에게만 글 작성을 허용하고 있습니다.</b><br /><strong>' + NP.dt.oNm + '</strong>님과 친구가 되어보세요.'
			});
		} else if ( writable === 2 ) {
			modal.show({
				txt : '<strong>' + NP.dt.oNm + '</strong>님은 글쓰기가 제재된 계정입니다.'
			});
		}*/
	});

	textarea.bind({
		keydown : function() {
			timer = setTimeout( check, 100 );
		},
		focusin : function( e ) {
			fake.width( textarea.width() ).insertAfter( textarea );
			writeShort.addClass( 'activeEditor' );
		},
		focusout : function() {
			clearTimeout( timer );
		}
	});

	// 글쓰기 완료
	buttonWrite.click(function() {
		var button = $( this ),
			timer,
			value = $.trim( textarea.val() ),
			postOpenSeq = writeShort.find( '.selectSetOpen label.checked' ).parent().index(),
			selectedCharacter = writeShort.find( '.selectSetChar .checked input' );

		if ( button.hasClass( 'ing' ) ) {
			return;
		}

		if ( !value.length && !NP.Image.getImages().length ) {
			modal.show({
				txt : '글 내용을 입력해주세요.',
				button : [[
					'confirm', function() {
						this.hide();
						textarea.focus();
					}
				]]
			});

			return;
		}
		
		if ( !NP.dt.v ) {
			modal.show({
				txt : '로그인이 필요합니다.',
				button : [[
					'confirm', function() {
						this.hide();
					}
				]]
			});

			return;
		}
		
		if( NP.dt.st === 'aion' && ( NP.dt.page === 'groupguestbook' || NP.dt.page === 'characterguestbook' || NP.dt.page === 'group' ) ){
			
			if( selectedCharacter.length && !selectedCharacter.attr( 'data-chrtnm' ) ){ 
				alert('캐릭터를 선택해주세요');
				return;
			}
			
			if( selectedCharacter.attr( 'data-writergamename' ) != 'aion'  ){
				alert('아이온 캐릭터만 글을 작성 하실 수 있습니다.');
				return;
			}
		};
		
		if( NP.dt.st === 'bns' && NP.dt.page === 'characterguestbook' ){
			/*
			if( selectedCharacter.length && !selectedCharacter.attr( 'data-chrtnm' ) ){ 
				alert('캐릭터를 선택해주세요');
				return;
			};
			*/
			
			if( selectedCharacter.val() != '0' && selectedCharacter.attr( 'data-writergamename' ) != 'bns'  ){
				alert('블소 캐릭터만 글을 작성 하실 수 있습니다.');
				return;
			};
		};

		
		$.ajax({
			type : 'post',
			url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.o + '/' + NP.dt.st + '/timeline/' + NP.dt.loc + '/post.jsonp',
			dataType : 'json',
			data : {
				page: NP.dt.page,
				characterId: NP.dt.characterId,
				guildId: NP.dt.guildId,
				serverId: NP.dt.serverId,
				postTxtLongCont : validate( value ).replace( /\n/g, '<br />' ),
				longContYn : 'N', // 단문 : 'N' | 장문 : 'Y'
				postOpenSeq : postOpenSeq + 1, // 1 : 전체공개, 2 : 친구공개
				trgtId : getParam( 'trgtId' ),
				imgIds : NP.Image.getImages().length ? NP.Image.getImages() : '',
				token : ( imgUploadG && NP.Image.getImages().length ) ? imgUploadG.getToken() : '',
				wrtChrtId : selectedCharacter.length ? selectedCharacter.attr( 'data-chrtid' ) : '',
				wrtChrtNm : selectedCharacter.length ? selectedCharacter.attr( 'data-chrtnm' ) : '',
				wrtSvrId : selectedCharacter.length ? selectedCharacter.attr( 'data-svrid' ) : '',
				writerGameName : selectedCharacter.length ? selectedCharacter.attr( 'data-writerGamename' ) : '',
				wrtGameSvrType : selectedCharacter.length ? selectedCharacter.attr( 'data-location' ) : '',
				'_method' : 'PUT'
			},
			beforeSend : function() {
				button.addClass( 'ing' );
				clearTimeout( timer );
				timer = setTimeout(function() {
					button.removeClass( 'ing' );
				}, 10000);
			},
			complete : function() {
				button.removeClass( 'ing' );
				clearTimeout( timer );
			},
			success : NP.Article.add,
			statusCode : {
				400 : function( data ) {
					var message;
					data = $.parseJSON( data.responseText );

					if ( data.code === 'profilePost.notfriend' ) {
						message = ( tplParser( NP.tmpl.message.notAllowed ) )( {} );
					} else if ( data.code === 'wrtPlayncAcctId.restrict' || data.code === 'crePlayncAcctId.restrict' ) {
						message = tplParser( NP.tmpl.message.restrict )();
					} else {
						message = data.message;
					}

					modal.show({
						txt : message,
						button : [[ 'confirm', function() {
							this.hide();
							textarea.focus();
						}]]
					});
				}
			}
		});
	});

	// 글쓰기 취소
	buttonWriteCancel.click(function() {
		NP.WriteForm.reset();
	});

	return {
		writeShort : writeShort,
		textarea : textarea,
		reset : function() {
			fake.html( '' );
			NP.Image.resetImages();
			NP.WriteForm.writeShort.find( '.wrap_willAddPhoto' ).remove();
			NP.WriteForm.writeShort.removeClass( 'activeEditor' );
			textarea.css( 'height', '' ).val( '' );
		},
		check : function( callback ) {
			if ( !NP.isLoading ) {
				var writable = NP.Timeline.writable(),
					openClfSeq = NP.Timeline.openClfSeq();
				
				if ( openClfSeq == '121' ){
					modal.show({
						txt : NP.dt.gNm + '방명록은 비공개 입니다.'
					});
					 return;
				}

				if ( writable === 1 ) {
					callback();
				} else if ( writable === 0 ) {
					if( !NP.dt.v ){
						modal.show({
							txt : '로그인이 필요합니다.',
							button : [[
								'confirm', function() {
									this.hide();
								}
							]]
						});
	
						return;
					}
					
					modal.show({
						txt : tplParser( NP.tmpl.message.notAllowed )()
					});
				} else if ( writable === 2 ) {
					modal.show({
						txt : tplParser( NP.tmpl.message.restrict )()
					});
				} else if ( writable === 3 ) {
					modal.show({
						txt : '글쓰기 권한이 없습니다.'
					});
				}
			} else {
				callback();
			}
		}
	};
}( jQuery ));


// Article
NP.Article = (function( $ ) {
	var tplParser = NP.ns( 'Util.tplParser' ),
		getParam = NP.ns( 'Util.getParam' ),
		defOpacity = 0.2,
		html,
		cachedArticle;

	/*
	// 좋아요 UI가 바뀌었으니.. 필요없을 듯
	NP.timeline.on( 'click', 'article .content .callSubArticle', function() {
		var el = $( this ),
			article = el.parents( 'article' ),
			subArticle = article.find( '.article.like' );

		if ( subArticle.length ) {
			subArticle.remove();
			//NP.fadeOut( subArticle );
			return;
		}

		$.ajax({
			dataType : 'jsonp',
			url : '/' + NP.dt.v + '/' + NP.dt.st + '/timeline/more.jsonp?' + $.param({
				lastNum : 0, // 글 목록 호출 시에는 0, 더보기 시에는 X번째
				page : 'wall', // timeline | wall
				trgtId : '',
				postTxtSeq : el.data( 'np' ).postTxtSeq
			}),
			success : function( data ) {
				NP.Timeline.setOne( data, el );
			}
		});
	});*/

	// 차단해제
	NP.timeline.on( 'click', 'article .revert', function() {
		if ( !cachedArticle ) {
			return;
		}

		var article = $( this ).parents( 'article:last' ),
			articleData = $.data( article[ 0 ] );

		$.ajax({
			type : 'get',
			dataType : 'json',
			url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/$!/'+ NP.dt.st +'/friend/' + articleData.wrtPlayncAcctId + '/propose/allow.jsonp',
			success : function( data ) {
				if ( data.result === 'SUCCESS' ) {
					article.html( cachedArticle.html() );

					cachedArticle = null;
				} else {
					modal.show({
						txt : '작업이 지연되고 있습니다. 잠시 후 이용 해 주세요.'
					});
				}
			},
			error : function() {
				modal.show({
					txt : '작업이 지연되고 있습니다. 잠시 후 이용 해 주세요.'
				});
			}
		});
	});

	return {
		setUI : function( data ) {
			if ( data.actType === 'EDIT_PROFILE_PHOTO' ) {
				return '<section class="wrap_activity actibity_changePhoto"><img src="' + NP.sfile( data.post.wrtPlayncAcctId, 'medium' ) + '" alt="' + data.post.wrtPlayncAcctNm + '"></section>';
			}

			return '';
		},
		setFrom : function( data ) {
			var html = '<span class="bar">|</span> ';

			/* if ( data.postTorg === 'GROUP' ) {
				html += '<span class="option">' + data.post.postTxtTorgNm + '</span> ';
			} */

			if ( data.post.postTxtOpenClfSeq === 118 ) { // 전체공개
				html += '<span class="access"><span class="js_tooltip all" data-tooltip="전체공개">전체공개</span></span>';
			} else if ( data.post.postTxtOpenClfSeq === 119 ) { // 친구공개
				html += '<span class="access"><span class="js_tooltip friend" data-tooltip="' + data.post.wrtPlayncAcctNm + '님의 친구공개">' + data.post.wrtPlayncAcctNm + '님의 친구공개</span></span>';
			} else if ( data.post.postTxtOpenClfSeq === 120 ) { // 그룹공개
				html += '<span class="access"><a href="/' + NP.dt.v + '/' + NP.dt.st + '/timeline/group?trgtId=' + data.post.postTxtTorgId + '">' + data.post.postTxtTorgNm + '</a> <span class="js_tooltip group" data-tooltip="' + data.post.postTxtTorgNm + '의 문파원공개">' + data.post.postTxtTorgNm + '의 문파원공개</span></span>';
			}
			
			if ( data.post.wrtLocClfSeq === 124 ) { // 모바일에서 작성한 글
				html += '<span class="from"><span class="mobile js_tooltip" data-tooltip="모바일에서">모바일에서</span></span>';
			}

			return html;
		},
		add : function( data ) {
			NP.now = data.now || +new Date(); // 서버로부터 받은 현재 시간

			data.timeline.post.postTxtLongCont = NP.AutoLink( data.timeline.post.postTxtLongCont );

			if ( NP.dt.loc === 'wall' && data.timeline.post.postTxtTorgId !== data.timeline.post.wrtPlayncAcctId && data.timeline.postTorg !== "GROUP" && data.timeline.postTorg !== "GROUP_RECEIVE" ) { // 다른 공간에 쓴 글, 그룹글은 제외
				data.timeline.postTorg = data.postTorg || data.timeline.postTorg;
				html = $( tplParser( NP.tmpl.articleTo )( data.timeline ) );
			} else {
				data.timeline.postTorg = data.postTorg || data.timeline.postTorg;
				html = $( tplParser( NP.tmpl.article )( data.timeline ) );
			}

			NP.onProcessing.fire( html, data.timeline );
			NP.timeline.prepend( html.css( 'opacity', defOpacity ) );
			NP.fadeIn( html );
			NP.WriteForm.reset();
		},
		'delete' : function( article ) { // 글 삭제
			var articleData = $.data( article[ 0 ] );
            var isDeleteCall = false;

			modal.show({
				txt : '이 글을 완전히 삭제하겠습니까?',
				button : [
					[ 'delete', function() {
						var me = this;

						if(isDeleteCall) return;

						isDeleteCall = true;

						$.ajax({
							type : 'post',
							url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/' + NP.dt.st + '/timeline/' + NP.dt.loc + '/post.jsonp',
							dataType : 'json',
							data : {
								page: NP.dt.page,
								characterId: NP.dt.characterId,
								guildId: NP.dt.guildId,
								serverId: NP.dt.serverId,
								postTxtSeq : articleData.postTxtSeq,
								trgtId : getParam( 'trgtId' ),
								'_method' : 'DELETE'
							},
							success : function( data ) {
								data = data.result;

								if ( data === 'SUCCESS' ) {
									var html = $( tplParser( NP.tmpl.deleteArticle )() );

									article.replaceWith( html.css( 'opacity', defOpacity ) );

									// REPAIR 20150807 - IE8 textnode opacity error
									var tmpHtml = html.get(0);
									if(tmpHtml.nodeType === 3) {
										html.css('opacity', 1).css('opacity', '');
									}else{
										NP.fadeIn( html );	
									}
									// NP.fadeIn( html );

									me.hide();
								}
							}
						});
					}],
					[ 'cancel' ]
				]
			});
		},
		link : function( article ) { // 이 글의 링크
			//window.open( NP.prflUri( NP.dt.o ) + '?postTxtSeq=' + $.data( article[ 0 ] ).postTxtSeq, '_blank' );
		},
		report : function( article ) { // 글 신고
			mustLoginIfHasNoSession() && NP.Report.getList( article );
		},
		hide : function( article ) { // 글 무시
			var articleData = $.data( article[ 0 ] );
			html = $( tplParser( NP.tmpl.hideArticle )() );

			$.ajax({
				type : 'post',
				url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/' + NP.dt.st + '/timeline/' + NP.dt.loc + '/post/hide.jsonp',
				dataType : 'json',
				data : {
					postTxtSeq : articleData.postTxtSeq,
					trgtId : getParam( 'trgtId' )
				},
				success : function( data ) {
					data = data.result;

					if ( data === 'SUCCESS' ) {
						article.replaceWith( html.css( 'opacity', defOpacity ) );
						NP.fadeIn( html );
					}
				}
			});
		},
		block : function( article ) { // 글 차단
			
			if( ! $( '#modalBlockFriend' ).length ){
				var layer = tplParser( NP.tmpl.modalBlockFriend )();
					layer = $( layer );
					NP.body.append( layer );
			}
			
			var articleData = $.data( article[ 0 ] ),
				html = $( tplParser( NP.tmpl.blockArticle )( articleData ) ),
				layer = $( '#modalBlockFriend' ),
				button = layer.find( '.wrap_button a' ).eq( 0 );

			layer.find( 'dt em' ).text( articleData.wrtPlayncAcctNm );
			button.unbind( 'click.block' );
			button.one( 'click.block', function( e ) {
				e.stopPropagation();
				modal.hide();

				$.ajax({
					type : 'get',
					dataType : 'json',
					url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/$!/'+ NP.dt.st +'/friend/' + articleData.wrtPlayncAcctId + '/propose/deny.jsonp',
					success : function( data ) {
						if ( data.result === 'SUCCESS' ) {
							layerManaged.hide();
							cachedArticle = article.clone();

							article.html( html.css( 'opacity', defOpacity ) );
							NP.fadeIn( html );
						}else if( data.result === 'ALREADY_DENY'){
							modal.show({
								txt : '이미 차단한 친구입니다.'
							});
						} else {
							modal.show({
								txt : '작업이 지연되고 있습니다. 잠시 후 이용 해 주세요.'
							});
						}
					},
					error : function() {
						modal.show({
							txt : '작업이 지연되고 있습니다. 잠시 후 이용 해 주세요.'
						});
					}
				});
			});

			modal.show( layer );
		},
		unfollow : function( article, menu ) { // 구독 취소
			menu.remove();
		}
	};
}( jQuery ));


// Reply
NP.Reply = (function( $ ) {
	var tplParser = NP.ns( 'Util.tplParser' ),
		validate = NP.ns( 'Util.validate' ),
		getParam = NP.ns( 'Util.getParam' ),
		getGUID = NP.ns( 'Util.getGUID' ),
		isLoading = false,
		loading = $( '<img src="' + NP.SANDBOX_URL + 'common/loading_tiny.gif" alt="로딩중" class="loading">' ),
		loading2 = $( '<img src="' + NP.SANDBOX_URL + 'common/loading_tiny.gif" alt="로딩중" class="loading2">' ),
		replyMaximum = 1000,
		defOpacity = 0.2,
		timer;

	// Set Data
	NP.onProcessingReply.add(function( reply, data ) {
		var item;
		$.each( reply, function( index ) {
			reply = $( this );
			item = data[ index ] || data;
			
			reply.attr( 'id', 'comment_' + item.rplyTxtSeq );

			$.data( reply[ 0 ], {
				rplyTxtSeq : item.rplyTxtSeq,
				wrtPlayncAcctId : item.wrtPlayncAcctId,
				wrtPlayncAcctNm : item.wrtPlayncAcctNm
			});

			// 댓글 시간
			$.each( reply, function( i ) {
				$.data( reply.eq( i ).find( 'time' )[ 0 ], {
					time : item.creDttm
				});
			});
		});
	});

	NP.onAfterTimelineLoad.add(function() {
		selectbox( '.wrap_form' );
		NP.Character.getCache() && NP.Character.set();
		
		NP.Character.setSelectOpen();
		NP.Character.hideSelectOpen();
		NP.Character.setSelectChar( tplParser( NP.tmpl.selectSetChar )( NP.Character.data ) );

		if( NP.dt.page == 'group' ){
			//레기온 가입 캐릭터 선택
			NP.Character.setLegionCharacter();
		}else{
			//대표캐릭터 선택
			//if( NP.dt.page != 'characterguestbook' )
				NP.Character.setMajorCharacter();
		}

		var postTxtSeq = getParam( 'postTxtSeq' ),
			isFocus = getParam( 'isFocus' );
		
		//글 작성 캐릭터 선택
		if( postTxtSeq ){
			NP.Character.setMyCharacter();
		}
		
		if( isFocus == '1' )
			NP.WriteForm.textarea.focus();
		
		NP.Timeline.setOpen();

	});
	
	// 댓글 쓰기
	NP.timeline.on( 'keydown', '.wrap_comment .comment input', function( e ) {
		if ( e.keyCode === 13 ) { // Enter
			
			
			
			var input = $( this ),
				
				reply = input.blur(),
				article = reply.parents( 'article:last' ),
				articleData = $.data( article[ 0 ] ),
				wrap = article.find( '.wrap_comment' ),
				replyList = wrap.find( '.list_comment' ),
				comment = wrap.find( '.comment' ),
				selectedCharacter = wrap.find( '.selectSetChar .checked input' ),
				articlePosttorg = article.attr( 'data-posttorg'),
				articlePosttxtservclfseq = article.attr( 'data-posttxtservclfseq' ),
				articlePostTxtTorgGameId = article.attr( 'data-postTxtTorgGameId' ),
				html;
			
			reply.focus();
			//IE에서 focus시 placeholer 제거 
			var cache = $.trim( input.val() ), 
				value = $.trim( reply.val() );
			
			if ( !cache.length || !value.length ) {
				//스티커 선택				
				if( !$( '.stickerPreview' ).is( ':visible' ) ){	
					return;
				};
			};

			if ( value.length > replyMaximum ) {
				modal.show({
					txt : replyMaximum + '자 이상 입력하실 수 없습니다.',
					button : [[ 'confirm', function() {
						reply.val( value.slice( 0, replyMaximum ) ).focus();
						this.hide();
					}]]
				});

				return;
			};

			if( NP.isNeedCharacter( {postTorg: articlePosttorg, postTxtServClfSeq: articlePosttxtservclfseq, postTxtTorgGameId: articlePostTxtTorgGameId} ) ){
				if( !selectedCharacter.attr( 'data-chrtid' )  ){
					alert('캐릭터를 선택해주세요');
					return;
				}
				
				if( selectedCharacter.attr( 'data-writergamename' ) != 'aion'  ){
					alert('아이온 캐릭터만 댓글을 작성 하실 수 있습니다.');
					return;
				}
			};
			
			if( NP.isNeedCharacterBns( {postTorg: articlePosttorg, postTxtServClfSeq: articlePosttxtservclfseq, postTxtTorgGameId: articlePostTxtTorgGameId} ) ){
				/*
				if( !selectedCharacter.attr( 'data-chrtid' )  ){
					alert('캐릭터를 선택해주세요');
					return;
				}
				*/
				
				if( selectedCharacter.val() != 0 && selectedCharacter.attr( 'data-writergamename' ) != 'bns'  ){
					alert('블소 캐릭터만 댓글을 작성 하실 수 있습니다.');
					return;
				}
			};
			
			//문파방명록 글일 때의 댓글 처리
			if( articlePosttorg == 'GROUP_GUESTBOOK' && articlePosttxtservclfseq == '145' && articlePostTxtTorgGameId == '102' ){
				if( selectedCharacter.attr( 'data-writergamename' ) == 'aion'  ){
					alert('블소 캐릭터만 댓글을 작성 하실 수 있습니다.');
					return;
				}
			}
			
			value = value + NP.MsgPreview.getSticker();

			$.ajax({
				type : 'post',
				url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/' + NP.dt.st + '/timeline/' + NP.dt.loc + '/reply.jsonp',
				dataType : 'json',
				data : {
					postTxtSeq : articleData.orgPostTxtSeq || articleData.postTxtSeq,
					rplyTxtCont : validate( value ),
					wrtGameId : '',
					wrtChrtId : selectedCharacter.length ? selectedCharacter.attr( 'data-chrtid' ) : '',
					wrtChrtNm : selectedCharacter.length ? selectedCharacter.attr( 'data-chrtnm' ) : '',
					wrtSvrId : selectedCharacter.length ? selectedCharacter.attr( 'data-svrid' ) : '',
					writerGameName : selectedCharacter.length ? selectedCharacter.attr( 'data-writerGamename' ) : '',
					wrtGameSvrType : selectedCharacter.length ? selectedCharacter.attr( 'data-location' ) : '',
					trgtId : getParam( 'trgtId' ),
					'_method' : 'PUT'
				},
				beforeSend : function() {
					comment.prepend( loading );

					clearTimeout( timer );
					timer = setTimeout(function() {
						loading.remove();
					}, 10000);
				},
				complete : function() {
					loading.remove();
					clearTimeout( timer );
				},
				success : function( data ) {
					data = data.reply;

					html = $( ( tplParser( NP.tmpl.reply ) )( {
						wrtPlayncAcctId : data.wrtPlayncAcctId,
						wrtPlayncAcctNm : data.wrtPlayncAcctNm,
						wrtChrtId : data.wrtChrtId,
						wrtGameId: data.wrtGameId,
						wrtChrtNm : data.wrtChrtNm,
						wrtSvrId : data.wrtSvrId,
						rplyTxtCont : NP.emoticonLayer.renderEmoticion( NP.AutoLink( validate( data.rplyTxtCont ) ) ),
						creDttm : data.creDttm,
						likeCnt : data.likeCnt,
						postTorg: articlePosttorg,
						postTxtServClfSeq: articlePosttxtservclfseq,
						postTxtTorgGameId: articlePostTxtTorgGameId,
						deletable : 'Y'
					} ) );

					NP.onProcessingReply.fire( html, data );

					if ( !replyList.length ) {
						replyList = $( tplParser( NP.tmpl.replyWrap )() );
						replyList.append( html.css( 'opacity', defOpacity ) );
						wrap.find( '.wrap_feedinfo' ).after( replyList );
					} else {
						replyList.append( html.css( 'opacity', defOpacity ) );
					}

					NP.fadeIn( html );

					NP.Reply.setCount( article, '+' );
					reply.val( '' ).focus();
					
					NP.emoticonLayer.hide();
					
				},
				statusCode : {
					400 : function( data ) {
						data = $.parseJSON( data.responseText );

						modal.show({
							txt : data.message,
							button : [[ 'confirm', function() {
								this.hide();
								reply.focus();
							}]]
						});
					}
				}
			});
		}
		return;
	});
	
	// Focus Reply Input
	NP.timeline.on( 'focus', '.wrap_comment .comment input', function( e ) {
		if ( !mustLoginIfHasNoSession() ) {
			return;
		};

		if ( !mustLoginIfHasNoSession() ) {
			var input = $( this );

			setTimeout(function() {
				input.blur();
			}, 50);
		}
		
		if ( !NP.dt.v ) {
			modal.show({
				txt : '로그인이 필요합니다.',
				button : [[
					'confirm', function() {
						this.hide();
					}
				]]
			});

			return;
		}		
	});

	// Reply Button
	NP.timeline.on( 'click', '.wrap_feed li.comment, .wrap_feed2 .wrapBtnComment', function() {
		if ( !mustLoginIfHasNoSession() ) {
			return;
		}
		
		if ( isLoading ) {
			return;
		}

		if ( !NP.dt.v ) {
			modal.show({
				txt : '로그인이 필요합니다.',
				button : [[
					'confirm', function() {
						this.hide();
					}
				]]
			});

			return;
		}		
		
		var button = $( this ),
			article = button.parents( 'article:last' ),
			articleData = $.data( article[ 0 ] ),
			reply = article.find( '.wrap_comment' );

		if ( !reply.is( ':visible' ) ) {
			$.ajax({
				type : 'get',
				url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + ( NP.dt.v || getGUID() ) + '/' + NP.dt.st + '/timeline/' + NP.dt.loc + '/reply.jsonp',
				dataType : 'json',
				data : {
					postTxtSeq : articleData.postTxtSeq,
					odr : 'desc', // 끝에서부터 보기
					lastNum : 0,
					trgtId : getParam( 'trgtId' ),
					currPage : '1'
				},
				beforeSend : function() {
					isLoading = true;
				},
				success : function( data ) {
					var replyCount = data.selector.totalCnt;
					
					//좋아요 한 글일 경우 해당글의 댓글을 단다
					if( article.hasClass( 'likeby' ) ){
						article = article.find( 'article' );
					}
					
					article.append( NP.Reply.setUI( data, true ) );
					NP.Reply.setCount( article, replyCount );
					// 댓글 호출 시 좋아요 카운트를 갱신해야하나....
					//NP.Like.setCount( article, data.postLikeCount );

					selectbox( '.wrap_form' );
					NP.Character.getCache() && NP.Character.set();
					
					var postTxtSeq = getParam( 'postTxtSeq' );
					
					if( postTxtSeq ){
						NP.Character.setMyCharacter();
					}

					if ( !replyCount ) { // 댓글이 없을 때 댓글 입력 박스에 focus
						article.find( '.wrap_comment .comment input[type="text"]' ).focus();
					}
				},
				complete : function() {
					isLoading = false;
				}
			});
		} else {
			reply.find( '.comment input' ).focus();
		}
	});

	// asc/desc Reply
	NP.timeline.on( 'click', '.wrap_feedinfo .sort', function() {
		var button = $( this ),
			comment = button.parents( '.wrap_comment' ),
			list = comment.find( '.list_comment' ),
			article = button.parents( 'article:last' ),
			articleData = $.data( article[ 0 ] ),
			order = button.hasClass( 'asc' ) ? 'asc' : 'desc',
			articlePosttorg = article.attr( 'data-posttorg'),
			articlePosttxtservclfseq = article.attr( 'data-posttxtservclfseq'),
			articlePostTxtTorgGameId = article.attr( 'data-postTxtTorgGameId');
				

		$.ajax({
			type : 'get',
			//url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/' + NP.dt.st + '/timeline/' + NP.dt.loc + '/reply.jsonp',
			url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.o + '/' + NP.dt.st + '/timeline/' + NP.dt.loc + '/reply.jsonp',
			dataType : 'json',
			data : {
				postTxtSeq : articleData.orgPostTxtSeq || articleData.postTxtSeq,
				odr : order,
				lastNum : 0,
				trgtId : getParam( 'trgtId' ),
				currPage : 1
			},
			beforeSend : function() {
				button.after( loading2 );

				clearTimeout( timer );
				timer = setTimeout(function() {
					loading2.remove();
				}, 10000);
			},
			complete : function() {
				loading2.remove();
				clearTimeout( timer );
			},
			success : function( data ) {
				var replyCount = data.selector.totalCnt,
					html = '',
					feed,
					item,
					i = 0;
				
				for ( ; item = data.replyList[ i ]; i += 1 ) {
					item.postTorg = articlePosttorg;
					item.postTxtServClfSeq = articlePosttxtservclfseq;
					item.postTxtTorgGameId = articlePostTxtTorgGameId;
					item.rplyTxtCont = NP.AutoLink( NP.Util.validate( item.rplyTxtCont ) );
					html += NP.emoticonLayer.renderEmoticion( ( tplParser( NP.tmpl.reply ) )( item ) );
				}

				html = $( html );

				NP.onProcessingReply.fire( html, data.replyList );

				list.html( html );
				comment.find( '.wrap_feedinfo .nav' ).remove();

				NP.Reply.setCount( article, replyCount );
				NP.Like.setCount( article, data.postLikeCount );

				// 이전/다음 댓글 보기를 위한 lastNum 값 삽입
				$.data( comment[ 0 ], {
					lastNum : data.selector.lastNum || 0,
					currPage : 2
				});

				if ( replyCount > data.replyList.length ) {
					feed = comment.find( '.wrap_feedinfo' );

					if ( order === 'asc' ) {
						feed = feed.eq( 1 );

						if ( feed.length ) {
							feed.append( '<p class="nav"><a class="next">다음 댓글 보기</a><a class="sort desc">끝에서부터 보기</a></p>' );
						} else {
							list.after( '<div class="wrap_feedinfo"><p class="nav"><a class="next">다음 댓글 보기</a><a class="sort desc">끝에서부터 보기</a></p></div>' );
						}
					} else {
						feed = feed.eq( 0 );

						if ( feed.length ) {
							feed.append( '<p class="nav"><a class="prev">댓이전 글 보기</a><a class="sort asc">처음부터 보기</a></p>' );
						} else {
							list.before( '<div class="wrap_feedinfo"><p class="nav"><a class="prev">이전 댓글 보기</a><a class="sort asc">처음부터 보기</a></p></div>' );
						}
					}
				}
			}
		});
	});

	// Next/Prev Reply
	NP.timeline.on( 'click', '.wrap_feedinfo .next, .wrap_feedinfo .prev', function() {
		var button = $( this ),
			comment = button.parents( '.wrap_comment' ),
			commentData = $.data( comment[ 0 ] ),
			list = comment.find( '.list_comment' ),
			article = button.parents( 'article:last' ),
			articleData = $.data( article[ 0 ] ),
			lastNum = commentData.lastNum || 0,
			articlePosttorg = article.attr( 'data-posttorg'),
			articlePosttxtservclfseq = article.attr( 'data-posttxtservclfseq'),
			articlePostTxtTorgGameId = article.attr( 'data-postTxtTorgGameId'),
			order,
			where;

		if ( button.hasClass( 'prev' ) ) {
			order = 'desc';
			where = 'prepend';
		} else {
			order = 'asc';
			where = 'append';
		}

		$.ajax({
			type : 'get',
			url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + ( NP.dt.o || '!!' ) + '/' + NP.dt.st + '/timeline/' + NP.dt.loc + '/reply.jsonp',
			dataType : 'json',
			data : {
				postTxtSeq : articleData.orgPostTxtSeq || articleData.postTxtSeq,
				odr : order,
				lastNum : lastNum,
				trgtId : getParam( 'trgtId' ),
				currPage : commentData.currPage || 1
			},
			beforeSend : function() {
				button.after( loading );

				clearTimeout( timer );
				timer = setTimeout(function() {
					loading.remove();
				}, 10000);
			},
			complete : function() {
				loading.remove();
				clearTimeout( timer );
			},
			success : function( data ) {
				var replyCount = data.selector.totalCnt,
					html = '',
					item,
					i = 0;

				for ( ; item = data.replyList[ i ]; i += 1 ) {
					item.postTorg = articlePosttorg;
					item.postTxtServClfSeq = articlePosttxtservclfseq;
					item.postTxtTorgGameId = articlePostTxtTorgGameId;
					item.rplyTxtCont = NP.AutoLink( NP.Util.validate( item.rplyTxtCont ) );
					html += NP.emoticonLayer.renderEmoticion( ( tplParser( NP.tmpl.reply ) )( item ) );
				}

				html = $( html );

				NP.onProcessingReply.fire( html, data.replyList );

				if ( lastNum ) {
					list[ where ]( html );
				} else {
					list.html( html );
				}

				if ( data.isLastPage ) {
					comment.find( '.wrap_feedinfo .nav' ).remove();
				}

				NP.Reply.setCount( article, replyCount );
				NP.Like.setCount( article, data.postLikeCount );

				// 이전/다음 댓글 보기를 위한 lastNum 값 삽입
				$.data( comment[ 0 ], {
					lastNum : data.selector.lastNum || 0,
					currPage : ( commentData.currPage || 1 ) + 1
				});
			}
		});
	});

	// Delete Reply
	NP.timeline.on( 'click', '.list_comment .delete', function() {
		var reply = $( this ).parents( 'li' ),
			article = reply.parents( 'article:last' ),
			articleData = $.data( article[ 0 ] );

		modal.show({
			txt : '이 댓글을 완전히 삭제하겠습니까?',
			button : [
				[ 'delete', function() {
					this.hide();

					$.ajax({
						type : 'post',
						url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/' + NP.dt.st + '/timeline/' + NP.dt.loc + '/reply.jsonp',
						dataType : 'json',
						data : {
							postTxtSeq : articleData.orgPostTxtSeq || articleData.postTxtSeq,
							rplyTxtSeq : $.data( reply[ 0 ] ).rplyTxtSeq,
							trgtId : getParam( 'trgtId' ),
							'_method' : 'DELETE'
						},
						success : function( data ) {
							reply.slideUp( 200, function() {
								$( this ).remove();
								NP.Reply.setCount( article, '-' );
							});
						}
					});
				}],
				[ 'cancel' ]
			]
		});
	});

	// Report Reply
	NP.timeline.on( 'click', '.list_comment .declare', function() {
		
		if ( !NP.dt.v ) {
			modal.show({
				txt : '로그인이 필요합니다.',
				button : [['confirm']]
			});

			return;
		}		
		
		mustLoginIfHasNoSession() && NP.Report.getList( $( this ).parents( 'li' ) );
	});
	
	// emoticon 
	NP.timeline.on( 'click', '.btnEmoticon', function() {
		var parentNode = $( this ).parents( '.wrap_comment' );
		NP.emoticonLayer.init( parentNode );
	});
	
	
	NP.timeline.on( 'click', '.wrapSticker .sticker img', function( e ){
		e.preventDefault();
		$( this )[ 0 ].src = $( this ).attr( 'src' );
	});

	return {
		setIsLoading : function( flag ) {
			isLoading = flag;
		},
		getIsLoading : function() {
			return isLoading;
		},
		//REPLY
		setUI : function( article, ignore ) {
//			if ( !ignore && !article.post.likeCnt && ( !article.replyList || !article.replyList.length ) ) { // 글 좋아요 카운트와 댓글이 없을 경우
//				return '';
//			}
			
			if ( !ignore && ( !article.replyList || !article.replyList.length ) ) { // 글 좋아요 카운트와 댓글이 없을 경우
				return '';
			}
			
			var html = '<section class="wrap_comment">',
				item,
				i = 0;

			if ( !ignore ) {
				html += ( tplParser( NP.tmpl.likeBox ) )( article );
			} else {
				html += ( tplParser( NP.tmpl.commentBox ) )( article );
			}
			html += '<ul class="list_comment">';

			for ( ; item = article.replyList[ i ]; i += 1 ) {
				item.rplyTxtCont = NP.AutoLink( NP.Util.validate( item.rplyTxtCont ) );
				item.postTorg = article.postTorg;
				item.postTxtServClfSeq = article.post.postTxtServClfSeq;
				item.postTxtTorgGameId = article.post.postTxtTorgGameId;
				html += NP.emoticonLayer.renderEmoticion( ( tplParser( NP.tmpl.reply ) )( item ) );
			}

			html += '</ul>';

			html += ( tplParser( NP.tmpl.replyForm ))( NP.Character.data );

			return html + '</section>';
		},
		/*setCount : function( article, vary ) {
			var count = article.find( '.comment strong span' ),
				value = vary || count.text();

			if ( vary === '+' ) {
				value = parseInt( count.text() ) + 1;
			} else if ( vary === '-' ) {
				value = parseInt( count.text() ) - 1;
			} else {
				value = vary;
			}

			count.text( value );

			return parseInt( count.text() );
		},*/
		setCount : function( article, vary ) {
			var countParent = article.find( '.wrapBtnComment' ), 
				count = article.find( '.wrapBtnComment .btnComment .count' ),
				value = vary || count.text();

			if ( vary === '+' ) {
				value = parseInt( count.text() ) + 1;
			} else if ( vary === '-' ) {
				value = parseInt( count.text() ) - 1;
			} else {
				value = vary;
			}

			( value >= 1 )? countParent.addClass( 'on' ): countParent.removeClass( 'on' );
			
			count.text( value );

			return parseInt( count.text() );
		},		
		setLikeCount : function( reply, vary ) {
			var count = reply.find( '.cFeed .count' ),
				value = vary || parseInt( count.text() );

			if ( vary === '+' ) {
				value = parseInt( count.text() ) + 1;
			} else if ( vary === '-' ) {
				value = parseInt( count.text() ) - 1;
			} else {
				value = vary;
			}

			if ( count.length ) {
				if ( value ) {
					count.text( value + '명' );
				} else {
					count.remove();
				}
			} else {
				count = reply.find( '.cFeed .like' ).after( ' <a class="count">1명</a>' );
			}

			return parseInt( count.text() );
		}
	};
}( jQuery ));


// Context Menu
NP.ContextMenu = (function( $ ) {
	var tplParser = NP.ns( 'Util.tplParser' );

	// Get Menu
	NP.timeline.on( 'click', '.wrap_menu .btn', function() {
		
		if ( !mustLoginIfHasNoSession() ) {
			return;
		};
		
		if ( !NP.dt.v ) {
			modal.show({
				txt : '로그인이 필요합니다.',
				button : [[
					'confirm', function() {
						this.hide();
					}
				]]
			});

			return;
		}

		var button = $( this ),
			menu = button.next(),
			articleData = $.data( button.parents( 'article:last' )[ 0 ] ),
			i = 0,
			item,
			html = '';
		
		var curl = location.href;
		
		curl = curl.replace( /[?||&]postTxtSeq=\d*/g.exec( curl ), '' );
		curl = ( curl.indexOf( '?' ) !== -1 )?
			curl + '&': curl + '?';

		articleData.currUrl = curl;

		$.ajax({
			type : 'get',
			url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.o + '/' + NP.dt.st + '/timeline/menu.jsonp',
			dataType : 'json',
			data : {
				wrt : articleData.wrtPlayncAcctId,
				own : articleData.postTxtTorgId,
				actType : articleData.actType,
				page : NP.dt.page,
				postTorg : articleData.postTorg,
				postOpen : articleData.postTxtOpenClfSeq
			},
			success : function( data ) {
				if ( data.menu ) {
					data = data.menu;

					for ( ; item = data[ i ]; i += 1 ) {
						item = ( tplParser( NP.tmpl.contextMenu[ item ] ) )( articleData );

						if ( item ) {
							html += item;
						}
					}

					layerManaged.toggle( button, menu.html( html ) );
				}
			}
		});
	});

	// Click Menu
	NP.timeline.on( 'click', '.wrap_menu .context a', function() {
		var menu = $( this ),
			junc = menu[ 0 ].className.split( ' ' )[ 0 ],
			article = menu.parents( 'article:last' );

		NP.Article[ junc ] && NP.Article[ junc ]( article, menu );
	});

	// Hide Menu
	NP.timeline.on( 'mouseleave', '.article', function() {
		layerManaged.hide();
	});
}( jQuery ));


// Report
NP.Report = (function( $ ) {
	var tplParser = NP.ns( 'Util.tplParser' ),
		layer = $( '#modalDeclareArticle' ) ,
		button = layer.find( '.wrap_button a' ).eq( 0 ),
		current;
	
	

	return {
		getList : function( target ) {
			
			if( !layer.length ){
				layer = tplParser( NP.tmpl.modalDeclareArticle )();
				
				layer = $( layer );
				
				button = layer.find( '.wrap_button a' ).eq( 0 );
				
				NP.body.append( layer );
			};	

			var targetData = $.data( target[ 0 ] );
			var articlePosttorg = target.attr( 'data-posttorg' ),
				articlePosttxtservclfseq = target.attr( 'data-posttxtservclfseq' ),
				articlePostTxtTorgGameId = target.attr( 'data-postTxtTorgGameId' );

			var rprtTrgtPlayncAcctNm = targetData.orgWrtPlayncAcctNm || targetData.wrtPlayncAcctNm;

			if( NP.isNeedCharacter( { postTorg: articlePosttorg, postTxtServClfSeq: articlePosttxtservclfseq, postTxtTorgGameId: articlePostTxtTorgGameId } ) ){
				rprtTrgtPlayncAcctNm = target.find( '.identity .game' ).text().replace(/^\[/, '').replace(/\]$/, '');

			}

			current = {
				rprtTrgtClfTxt : targetData.postTxtSeq ? 'posttxt' : 'rplytxt',
				rprtTrgtSeq : ( targetData.orgPostTxtSeq || targetData.postTxtSeq ) || targetData.rplyTxtSeq,
				rprtClfSeq : '',
				rprtTrgtPlayncAcctId : targetData.orgWrtPlayncAcctId || targetData.wrtPlayncAcctId,
				rprtTrgtPlayncAcctNm : rprtTrgtPlayncAcctNm
			};

			$.ajax({
				type : 'get',
				url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/' + NP.dt.st + '/reportInfo.jsonp',
				dataType : 'jsonp',
				success : function( data ) {
					var html = '',
						item,
						i = 0;

					// 남은신고횟수
					layer.find( '.count' ).text( data.rprtNum );

					// 신고자
					layer.find( '.reporter' ).text( NP.dt.vNm );

					// 신고일시
					layer.find( '.date' ).text( data.rprtDate );

					// 신고대상자
					layer.find( '.target' ).text( current.rprtTrgtPlayncAcctNm );

					// 신고사유
					for ( ; item = data.rprtType[ i ]; i += 1 ) {
						html += '<input type="radio" name="clf" value="' + item.cdSeq + '" /> ' + item.cdNm + ' <br />';
					}
					layer.find( '.list' ).html( html );

					button.bind( 'click', NP.Report.it );
					modal.show( layer );
				}
			});
		},
		it : function() {
			button.unbind( 'click', NP.Report.it );
			current.rprtClfSeq = layer.find( ':checked' ).val();

			if ( !current.rprtClfSeq ) {
				modal.hide();
				modal.show({
					txt : '신고사유를 선택해주세요.'
				});

				return;
			}

			$.ajax({
				type : 'get',
				url : ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/' + NP.dt.st + '/report.jsonp',
				dataType : 'jsonp',
				data : current,
				success : function( data ) {
					modal.hide();

					if ( data.reportResult === 'SUCCESS' ) {
						modal.show({
							txt : '신고 처리 되었습니다.'
						});
						current = null;
					} else if ( data.reportResult === 'DUPLICATION' ) { // 중복 신고
						modal.show({
							txt : '이미 신고처리 되었습니다.'
						});
					} else if ( data.reportResult === 'EXPIRE' ) { // 신고횟수 초과
						modal.show({
							txt : '게시물 신고는 하루에 20회까지 가능합니다.'
						});
					}
				}
			});
		}
	};
}( jQuery ));


// Image
NP.Image = (function( $ ) {
	var tplParser = NP.ns( 'Util.tplParser' ),
		tempImages = [],
		maxImages = 5,
		width,
		height;

	function focusOn( pane, index ) {
		var navi = pane.find( 'nav a' ),
			list = pane.find( 'ul li' );

		navi.removeClass( 'on' ).eq( index ).addClass( 'on' );
		list.css( 'zIndex', 1 ).eq( index ).css( 'zIndex', 3 );
	}

	// Thumbnail Image resizing
	NP.onProcessing.add(function( article ) {
		var images = article.find( '.wrap_addedPhoto li img' ).css( 'opacity', 0.8 );

		images.load(function() {
			var image = $( this ),
				width = image[ 0 ].width,
				frameWidth = image.parents( 'ul' ).width(),
				li = image.parents( 'li' ),
				wrap = image.parents( '.wrap_addedPhoto' );

			if ( !li.siblings().length ) {
				wrap.addClass( 'wrap_addedPhotoOpen' ).removeClass( 'wrap_addedPhoto' );
			}

			if ( width > frameWidth ) {
				li.addClass( 'overWidth' );
			}

			NP.fadeIn( image );
			focusOn( wrap, 0 );
		});
	});

	// Thumbnail viewer
	NP.timeline.on( 'mouseenter', '.wrap_addedPhoto nav a', function() {
		var navi = $( this ),
			pane = navi.parents( '.wrap_addedPhoto' );

		focusOn( pane, navi.index() );
	});
	NP.timeline.on( 'click', '.wrap_addedPhoto .open', function() {
		var button = $( this ),
			pane = button.parents( '.wrap_addedPhoto' );

		pane.addClass( 'wrap_addedPhotoOpen' ).removeClass( 'wrap_addedPhoto' );
	});

	// Thumbnail Image viewer
	NP.timeline.on( 'click', '.wrap_addedPhoto li img, .wrap_addedPhotoOpen li img', function() {
		var i = 0,
			image,
			list = [],
			me = $( this ),
			src = me.attr( 'src' ),
			images = me.parents( 'ul' ).find( 'img' );

		if ( !Viewer ) {
			Viewer = new nc.playinG.ImageViewer( NP.body[ 0 ], {
				isComment: false,
				channel: 'SNS'
			});
		}

		Viewer.onLoaded.removeAll();
		Viewer.onLoaded.add(function() {
			var i = 0,
				image,
				imageIdx;

			for( ; image = images[ i ]; i += 1) {
				if ( src === images.eq( i ).attr( 'src' ) ) {
					imageIdx = i;
					break;
				}
			}

			if( imageIdx ) {
				Viewer.setSelectImageByIndex( imageIdx );
			}

			Viewer.show();
		}, NP.win[ 0 ]);

		for ( ; image = images[ i ]; i += 1 ) {
			list.push( image.src.replace( /\/download_?\w*\//, '/download/' ) );
		}

		Viewer.setImages([{
			id : '',
			length : list.length,
			albumNm : '',
			albumUrl : '',
			list : list
		}]);
	});

	//문파 의상실 재료
	NP.onAfterTimelineLoad.add(function() {
		$( '.gf_groupUniform .wrapThumb' ).css( {'cursor':'pointer'} );
		$( '.gf_groupUniform .itemShortage' ).css( {'cursor':'pointer'} );
	});

	var gotoPowerbook = function( node ){
		var _$this = $( node );
		var title = _$this.attr( 'title' );
		var rcTxt = /rc./.test( location.host ) ? 'rc.' : '';
		var powerbookUrl = 'https://bns.power.plaync.com/wiki/';

		if( _$this.parents( 'article' ).attr( 'data-gameid' ) === '102' ){
			location.href = powerbookUrl + title;
		};	
	};

	NP.timeline.on( 'click', '.gf_groupUniform .wrapThumb', function() {
		gotoPowerbook( this );	
	});

	NP.timeline.on( 'click', '.gf_groupUniform .itemShortage', function() {
		gotoPowerbook( this );	
	});

	// Image Attach
	$('.addData .photo').click(function() {
		
		if ( !NP.dt.v ) {
			modal.show({
				txt : '로그인이 필요합니다.',
				button : [[	'confirm' ]]
			});

			return;
		}
		
		mustLoginIfHasNoSession() && NP.WriteForm.check(function() {
			if ( !imgUploadG ) {
				
				var ImgUploadGData = {
						channel: 'SNS',
						tokenUrl:  ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/SNS/photo/createToken.json',
						fileInfo: ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/SNS/photo/tokenfileinfo.json',
						removeFileInfo: ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/SNS/photo/deleteFile.json',
						iframe: NP.dt.imgUploadFrame || '/resources/jsp/editor/btnFileUpload.html',
						editFrame: NP.dt.imgUploadEditFrame || '/resources/jsp/editor/FileModify.html',
						filterImageUrl: NP.dt.imgUploadEditFrame || '/resources/jsp/editor/symbol/',
						//thumbnailUrl: NP.FILESVR_URL + 'download_thumblarge/',
						thumbnailUrl: NP.FILESVR_URL + 'download/',
						validateTokenInfo: ( ( NP.dt.prefixUrl )? NP.dt.prefixUrl: '' ) + '/' + NP.dt.v + '/SNS/photo/validateToken',
						maxImages: maxImages,
						objectName : 'imgUploadG',
						onComplete : NP.Image.add,
						isUrlUpload: false,
						localFileEnable : true
					};
				
				imgUploadG = new nc.playinG.ImageUpload( document.body, ImgUploadGData );
			} else {
				imgUploadG.setMaxImages( maxImages - tempImages.length );

				if ( tempImages.length >= maxImages ) {
					modal.show({
						txt : '등록하실 수 있는 최대 파일갯수를 초과하였습니다.'
					});

					return;
				}

				imgUploadG.init();

				if ( tempImages.length == 0 ) {
					imgUploadG.showNewToken();
				}
				else {
					imgUploadG.show();
				}
			}
		});

		return false;
	});

	// Delete Uploaded Image
	NP.WriteForm.writeShort.on( 'click', '.wrap_willAddPhoto .delete', function() {
		NP.Image.remove( $( this ).parent() );
	});

	return {
		setUI : function( images ) {
			if ( !images[ 0 ] && images[ 0 ] == null ) {
				return '';
			}

			var image,
				len = images.length > 1,
				//html = '<section class="wrap_addedPhoto' + ( !len ? 'Open' : '' ) + '">',
				html = '<section class="wrap_addedPhoto">',
				i = 0,
				j = 0;

			if ( len ) {
				html += '<nav>';
				for ( ; image = images[ i ]; i += 1 ) {
					html += ' <a><span>' + i + '</span></a>';
				}
				html += '</nav>';
			}

			html += '<ul>';
			var imgfilesvr = 'https://imgfiles-cdn.plaync.com/'
			if ( /rc\.|rc\-/.test( location.host ) ) {
				imgfilesvr = 'https://rc-imgfiles.plaync.com/'
			}
			for ( ; image = images[ j ]; j += 1 ) {
				//html += '<li><div><img src="' + NP.FILESVR_URL + 'download_thumblarge/' + image.imgId + '" alt="" /></div></li>';
				html += '<li><div><img src="' + imgfilesvr + '/file/' + ( image.imgSvrId.split( ':' )[ 1 ] || 'SNS' ) + '/download_thumblarge/' + image.imgId + '" alt="" /></div></li>';
			}
			html += '</ul>';

			if ( len ) {
				html += '<a class="open">펼치기</a>';
			}

			return html + '</section>';
		},
		getImages : function() {
			return tempImages;
		},
		resetImages : function() {
			tempImages = [];
		},
		add : function( images ) {
			if ( !images.length ) {
				return;
			}

			NP.WriteForm.textarea.focus();

			if ( !NP.WriteForm.writeShort.find( '.wrap_willAddPhoto' ).length ) {
				NP.WriteForm.writeShort.find( '.wrap_button' ).before( tplParser( NP.tmpl.wrapImage )() );
			}

			var image,
				i = 0, j = 0;

			var li = NP.WriteForm.writeShort.find( '.wrap_willAddPhoto li' ),
				frameWidth = li.width(),
				frameHeight = li.height(),
				width, height;

			for ( ; image = images[ i ]; i += 1 ) {
				image.fileUrl = image.fileUrl.replace( /\/download_?\w*\//, '/download_thumbmedium' );

				var curLi = li.eq( tempImages.length );
				curLi.html( tplParser( NP.tmpl.imageFrame )() );
				curLi.attr('file-id', image.id);


				var tmpImage = new Image();
				tmpImage.timer = setTimeout(function() {
					NP.Image.remove( curLi );
					modal.show({
						txt : '이미지 업로드에 실패 하였습니다.<br />다시 시도 해 주세요.'
					});
				}, 10000);
				$(tmpImage).attr( 'src', image.fileUrl ).load(function() {
					clearTimeout( this.timer );
					var _this = $( this );

					width = _this[0].width;
					height = _this[0].height;

					if ( (height*frameWidth) < (width*frameHeight) && frameWidth < width ) {
						_this.css({
							width : frameWidth,
							height : 'auto'
						});
					} else if ( frameHeight < height ) {
						_this.css({
							width : 'auto',
							height : frameHeight
						});
					}

					_this.prev().remove();
					_this.css('display', 'inline');

				});
				curLi.find('img').after( $(tmpImage).hide() );

				tempImages.push( image.id || image.fileUrl );
			}
		},
		remove : function( cur ) {
			$(cur).parent().append( '<li></li>' );
			var tmpWillAddPhoto = [];
			for( var i=0 ; i<tempImages.length ; i++){
				if( tempImages[i]!= $(cur).attr('file-id') ){
					tmpWillAddPhoto.push( tempImages[i] );
				}
			}
			tempImages = tmpWillAddPhoto;

			$(cur).remove();
			if( imgUploadG ){
				imgUploadG.setMaxImages( 5 - tempImages.length );
			}
			if( !tempImages.length ){
				NP.WriteForm.writeShort.find( '.wrap_willAddPhoto' ).remove();
			}
		}
	};
}( jQuery ));


// More
NP.More = (function( $ ) {
	var moreButton,
		more = NP.timeline.next( '.btn_moreData' ),
		ing,
		timer,
		time = 10000;

	function reset() {
		clearTimeout( timer );

		more.find( '.ing' ).hide();
		more.find( '.ready' ).show();
	}

	NP.onAfterTimelineLoad.add( reset );

	if ( NP.timeline.length ) {
		NP.contents.on( 'click', '.btn_moreData', function() {
			var el = $( this );

			if ( el.find( '.ing' ).is( ':visible' ) ) {
				return;
			}

			moreButton = el.find( '.ready' ).hide();
			ing = el.find( '.ing' ).css( 'display', 'inline-block' );

			timer = setTimeout( reset, time );

			NP.Timeline.get( NP.Timeline.getLastNum() );
		});
	}

	return {
		show : function() {
			more.show();
		},
		clear : function() {
			more.remove();
		},
		reset : reset
	};
}( jQuery ));

}
